export default __webpack_public_path__ + "static/media/ps_11.74bca8bc.png";